export const OVERRIDE_RULES_CONFIG_KEY = 'claim_override_rules';

/** When a payment needs a manager's approval first. Both are off by default. */
export interface Rules extends Record<string, unknown> {
  /** In cents; null turns the rule off. */
  netPayableOver: number | null;
  /** When a split pays the customer part of the money. */
  customerShare: boolean;
}

export function getRules(config: Partial<Rules> | null | undefined): Rules {
  return {
    netPayableOver: typeof config?.netPayableOver === 'number' ? config.netPayableOver : null,
    customerShare: config?.customerShare === true,
  };
}
